module.exports = __webpack_public_path__ + "img/BSE_logo_horizontal_light.2537760e.png";